'use strict';

import React from 'react'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

import Modal from '@Modal/Modal'

import _ from 'lodash'

const moment = window.moment;

export default class UpdateAbondementModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			data: { }
		};

		this.handleClose = this.handleClose.bind(this);
		this.validate    = this.validate.bind(this);
		this.open        = this.open.bind(this);
	}

	componentDidMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'open__UpdateAbondementModal',
			cb: component.open
		});

		component.setState(
		{
			open: false,
			created: undefined,
			error: undefined,
			data: { }
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'open__UpdateAbondementModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			data: { },
			created: undefined,
			error: undefined
		});
	}

	/**
	 * data:
	 * {
	 * 		products: Array of products ids
	 * 		qty:      qty per EC member
	 * 		value:    value
	 * }
	 */
	open (data)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: data
		});
	}

	validate (e)
	{
		const component = this, props = this.props, state = this.state;

		qwest.post('/abondement/update-product-abondement', state.data)
		.then(function (xhr, response)
		{
			component.setState(
			{
				created: true
			});

			app.emit('updatedProductAbondement',
			{
				source: 'UpdateAbondementModal',
				abondement: _.cloneDeep(state.data)
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			component.setState(
			{
				error: response.error
			});
		});
	}

	render (e)
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let info =
		(
			<p>
				Êtes-vous sûr de vouloir modifier cet abondement&nbsp;?
			</p>
		);

		let create_btn;

		if (state.created === true)
		{
			info =
			(
				<div className="c-message c-message--green">
					<div className="c-form-message__content">
						L'abondement a bien été mis à jour.
					</div>
				</div>
			);
		}
		else
		{
			create_btn =
			(
				<button className="c-btn c-dialog__danger u-margin-right-10"
					onClick={ component.validate }>
					Mettre à jour l'abondement
				</button>
			);
		}

		const form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

	/**
	 * Map all status from component.state and return information messages accordingly.
	 *
	 * @param    { Object }    status_data    Infos messages to display.
	 * @param    { String }    index          Iteratof.
	 *
	 * @return    [Array]      Renderable React elements.
	 */
		let status = form_status
		.filter(status_data => typeof state[status_data.label] !== 'undefined')
		.map(function (status_data, index)
		{
			var message =
			(
				<div key={ index } className={ 'c-form-message ' +
					'c-form-message' + status_data.suffix }>
					<div className="c-form-message__content">
						{ state[status_data.label] }
					</div>
				</div>
			);

			return message;
		});

		let output =
		(
			<Modal className="o-modal" open={ component.state.open }
				hide_close={ true } title="Nouvel abondement"
				onClose={ component.handleClose }>

				{ info }

				{ status }

				<div className="c-dialog__buttons">
					{ create_btn }

					<button className="c-btn c-dialog__cancel u-margin-right-0"
						onClick={ component.handleClose }>
						Fermer
					</button>
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
